import configdata from "../../config.json";
import { leafStockSliceAction } from "./LeafStockSlice";
import { getApi } from "../BaseApi";
import { getOnlyValueFromSelectObject } from "../UseAbleFun";
import { appLevelSliceActions } from "../AppLevelApi/AppLevelSlice";
export const getAllLeafStocksItems = () => {
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    const res = await getApi("get", `${configdata.SERVER_URL}/api/leaf-stocks`);
    console.log(res);
    dispatch(appLevelSliceActions.setLoadingState());

    dispatch(leafStockSliceAction.getAllLeafStocks(res.data.leafStock));
  };
};
export const createLeafStockItem = (data, duplicateData, createOrAddMore) => {
  console.log(data);
  // let newDuplicateData = { ...duplicateData };

  // const leafTypeList = newDuplicateData.leaf_type.map((item) => {
  //   const value = item.value;
  //   return value;
  // });

  // newDuplicateData.leaf_type = leafTypeList;

  // data = { ...data, ...newDuplicateData };
  // data.push({ ...newDuplicateData });
  const { form } = getOnlyValueFromSelectObject(data);

  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());

    let resurl = `${configdata.SERVER_URL}/api/leaf-stocks/store`;

    let resData = await getApi("post", resurl, form);
    if (resData?.error) {
      if (resData?.errorType === "single") {
        dispatch(
          appLevelSliceActions.setError({ msg: resData.message, isError: true })
        );
      } else {
        dispatch(
          leafStockSliceAction.setErrorData({
            message: resData.message,
            isError: true,
          })
        );
      }

      dispatch(appLevelSliceActions.setLoadingState());
      return;
    }
    dispatch(
      leafStockSliceAction.setErrorData({
        message: {},
        isError: false,
      })
    );
    dispatch(appLevelSliceActions.setIsSuccess(true));
    dispatch(leafStockSliceAction.setInitialData());
    dispatch(leafStockSliceAction.setDuplicateInitialData());
    dispatch(appLevelSliceActions.setLoadingState());
    window.location.reload(false);
    dispatch(getAllLeafStocksItems());
  };
};
export const getDataForEdit = (id, qualityList) => {
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    const res = await getApi(
      "get",
      `${configdata.SERVER_URL}/api/leaf-stocks/edit/${id}`
    );

    dispatch(appLevelSliceActions.setLoadingState());
    const data = { ...res.data.leafStock[0] };

    const quality = qualityList.find((item) => {
      return item.value === data.quality_id;
    });

    data.quality = {
      value: quality.value,
      label: quality.label,
      type: quality.type,
    };
    data.status = {
      value: `${data.status}`,
      label: data.status === "active" ? "Active" : "Deactive",
      type: "status",
    };
    data.discount_type = {
      value: `${data.discount_type}`,
      label: data.discount_type === "flat" ? "Flat" : "%",
      type: "discount_type",
    };

    dispatch(leafStockSliceAction.getLeafStockDataEdit(data));
  };
};

export const adjustLeafStockItem = (data, adjustedData, duplicateData) => {
  const newDuplicateData = { ...duplicateData };
  const leafTypeList = duplicateData.leaf_type.map((item) => {
    const value = item.value;
    return value;
  });
  newDuplicateData.leaf_type = leafTypeList;

  data = { ...data, ...newDuplicateData, ...adjustedData };
  // data.push({ ...newDuplicateData });
  const { form } = getOnlyValueFromSelectObject(data);

  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    const resData = await getApi(
      "post",
      `${configdata.SERVER_URL}/api/leaf-stocks/update/${data.id}`,
      form
    );

    if (resData?.error) {
      if (resData?.errorType === "single") {
        dispatch(
          appLevelSliceActions.setError({ msg: resData.message, isError: true })
        );
      } else {
        dispatch(
          leafStockSliceAction.setErrorData({
            message: resData.message,
            isError: true,
          })
        );
      }

      dispatch(appLevelSliceActions.setLoadingState());
      return;
    }
    dispatch(
      leafStockSliceAction.setErrorData({
        message: {},
        isError: false,
      })
    );
    dispatch(appLevelSliceActions.setIsSuccess(true));
    dispatch(leafStockSliceAction.setInitialData());
    dispatch(leafStockSliceAction.setDuplicateInitialData());
    dispatch(appLevelSliceActions.setLoadingState());
    window.location.reload(false);
    dispatch(getAllLeafStocksItems());
  };
};

export const deleteLeafStockItem = (id) => {
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    await getApi(
      "get",
      `${configdata.SERVER_URL}/api/leaf-stocks/delete/${id}`
    );
    dispatch(appLevelSliceActions.setIsSuccess(true));
    dispatch(appLevelSliceActions.setLoadingState());
  };
};

export const getBillListForVendor = (id) => {
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    const res = await getApi(
      "get",
      `${configdata.SERVER_URL}/api/leaf-stocks/show/${id}`
    );
    dispatch(appLevelSliceActions.setLoadingState());
    const data = res.data.data.map((item) => {
      return { value: item, label: item, type: "bill_number" };
    });
    if (data.length > 0) {
      dispatch(leafStockSliceAction.getBillList({ data: data }));
    } else {
      dispatch(leafStockSliceAction.getBillList({ data: [] }));
    }
  };
};

export const getDataForAfterBill = (billNumber) => {
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    const res = await getApi(
      "get",
      `${configdata.SERVER_URL}/api/leaf-stocks/edit/${billNumber}`
    );
    dispatch(appLevelSliceActions.setLoadingState());
    const quantities = [];
    const pricePerLeaf = [];
    const type = [];
    let arrayLength = 0;
    res.data.data.forEach((item) => {
      quantities.push(item.quantity);
      pricePerLeaf.push(item.price_per_leaf);
      type.push({
        value: item.name,
        label: item.name,
        type: "leaf_type",
      });
      arrayLength = arrayLength + 1;
    });
    const data = {
      quantity: quantities,
      price_per_leaf: pricePerLeaf,
      leaf_type: type,
      arrayLength: arrayLength,
    };
    const otherDataWithOutArray = {
      id: parseInt(res.data.data[0].type_id),
      purchase_date: res.data.data[0].purchase_date,
      paid_amount: res.data.data[0].paid_amount,
      total_amount: res.data.data[0].total_amount,
    };

    dispatch(
      leafStockSliceAction.getDataUsingBill({
        data: data,
        editData: otherDataWithOutArray,
      })
    );
  };
};
